//Login 

export const LOGIN = `${process.env.REACT_APP_API_URL}/login`

export const VERIFY_RECAPTCHA = `${process.env.REACT_APP_API_URL}/verify-recaptcha`


//Matchlist
export const MATCHLIST = `${process.env.REACT_APP_API_URL}/match_list?status=:status&page=:default`

export const MATCHLISTPUBSUB = `${process.env.REACT_APP_API_URL}/pub_sub`

export const GLOBALLIST = `${process.env.REACT_APP_API_URL}/global_list`

export const GLOBAL = `${process.env.REACT_APP_API_URL}/upload_global_image/match/:match_id`


//User
export const  USER = `${process.env.REACT_APP_API_URL}/user/:user_id`


//IN Play End Points
export const INPLAY = `${process.env.REACT_APP_API_URL}/in_play/match/:match_id/series/:series_id`

export const CHANGESTATUS = `${process.env.REACT_APP_API_URL}/change_status/in_play`

export const SUSPENDINPLAY = `${process.env.REACT_APP_API_URL}/suspend/in_play`

export const  INPLAY_CHANGE_ALL_STATUS = `${process.env.REACT_APP_API_URL}/change_all_status/inplay`

export const CANCEL_IN_PLAY = `${process.env.REACT_APP_API_URL}/cancel/in_play`

export const WINNING_SET_IN_PLAY = `${process.env.REACT_APP_API_URL}/winning_set/in_play`

export const WINNING_DISTRIBUTION_IN_PLAY = `${process.env.REACT_APP_API_URL}/winning_distribution/in_play`

export const FORCE_CANCEL_IN_PLAY = `${process.env.REACT_APP_API_URL}/force_cancel/in_play/prediction_id/:prediction_id`

export const IN_PLAY_RATE_CHANGE = `${process.env.REACT_APP_API_URL}/in_rate_change/:match_id`

export const INPLAY_TRANSACTION = `${process.env.REACT_APP_API_URL}/inplay_transactions`



//Poll End

export const PREDICTION = `${process.env.REACT_APP_API_URL}/prediction/match/:match_id/series/:series_id`

export const PREDICTION_FORCE_CANCEL = `${process.env.REACT_APP_API_URL}/force_cancel/prediction/:prediction_id`

export const PREDICTION_CHANGE_STATUS = `${process.env.REACT_APP_API_URL}/change_status/prediction/:prediction_id`

export const PREDICTION_CANCEL= `${process.env.REACT_APP_API_URL}/cancel/prediction/:prediction_id`

export const PREDICTION_WINNING_SET= `${process.env.REACT_APP_API_URL}/winning_set`

export const PREDICTION_DISTRIBUTE_WINNING= `${process.env.REACT_APP_API_URL}/distribute_winning/prediction/:id`

//Trading 

export const TRADING_LIST = `${process.env.REACT_APP_API_URL}/trading/match/:match_id/series/:series_id/sport/:sport`

export const  SKILLER_LIST = `${process.env.REACT_APP_API_URL}/skiller/match/:match_id/series/:series_id`


export const TRADING_CHANGE_STATUS = `${process.env.REACT_APP_API_URL}/change_status/trading`

export const TRADING_HOME_SCREEN = `${process.env.REACT_APP_API_URL}/home_screen`

export const  SKILLER_CHANGE_STATUS = `${process.env.REACT_APP_API_URL}/change_status/skiller`

export const  TRADING_CHANGE_ALL_STATUS = `${process.env.REACT_APP_API_URL}/change_all_status/trading`

export const TRADING_CANCEL = `${process.env.REACT_APP_API_URL}/cancel/trading/match/:match_id/series/:series_id/trade/:prediction_id`

export const  SKILLER_CANCEL = `${process.env.REACT_APP_API_URL}/cancel/skiller/match/:match_id/series/:series_id/skiller/:skiller_id`


export const TRADING_DISTRIBUTE_WINNING = `${process.env.REACT_APP_API_URL}/winning_distribute/trading/match/:match_id/trade/:prediction_id?sport=sport_id`

export const  SKILLER_DISTRIBUTE_WINNING = `${process.env.REACT_APP_API_URL}/winning_distribute/skiller/match/:match_id/skiller/:skiller_id`


export const TRADING_FORCE_CANCEL = `${process.env.REACT_APP_API_URL}/force_cancel/trading/trade/:prediction_id`

export const  SKILLER_FORCE_CANCEL = `${process.env.REACT_APP_API_URL}/force_cancel/skiller/:skiller_id`


export const  CHECK_TOTAL_TRADES_TRADING = `${process.env.REACT_APP_API_URL}/trade_count/match/:match_id/sport/:sport/trade/:id`

export const TRADING_WINNING_SET = `${process.env.REACT_APP_API_URL}/winning_set/trading/match/:match_id/series/:series_id/trade/:id`
export const SKILLER_WINNING_SET = `${process.env.REACT_APP_API_URL}/winning_set/skiller/match/:match_id/series/:series_id/skiller/:id`


export const TRADE_ANALYTICS = `${process.env.REACT_APP_API_URL}/trade_analytics?phone_number=phonenumber&page=pageno&match_id=matchId`

export const TRADE_TRANSACTION = `${process.env.REACT_APP_API_URL}/trade_transactions`

export const GET_MATCH_NAME = `${process.env.REACT_APP_API_URL}/getMatchDetails/match/:match_id`

export const PREDICTION_ANALYTICS = `${process.env.REACT_APP_API_URL}/prediction_analytics?phone_number=phonenumber&match_id=matchId`

export const INPLAY_ANALYTICS = `${process.env.REACT_APP_API_URL}/in_play_analytics?phone_number=phonenumber&match_id=matchId`

export const SKILLER_ANALYTICS = `${process.env.REACT_APP_API_URL}/skiller_analytics?phone_number=phonenumber&match_id=matchId`

export const TRADE_MANAGE_RATE = `${process.env.REACT_APP_API_URL}/manage_rate/:match_id/:prediction_id?sport=sport_id`

//ScoreCard
export const GET_SCORE_CARD = `${process.env.REACT_APP_API_URL}/scorecard/:match_id/:series_id`
export const SET_TEAM_DETAILS = `${process.env.REACT_APP_API_URL}/team/:match_id/:series_id`


//get Category

export const GET_CATEGORY = `${process.env.REACT_APP_API_URL}/category`

export const ADD_CATEGORY = `${process.env.REACT_APP_API_URL}/category`

export const CHANGE_STATUS_CATEGORY = `${process.env.REACT_APP_API_URL}/category_status`

export const CATEGORY_QUESTIONS = `${process.env.REACT_APP_API_URL}/category_questions/match/:match_id/series/:series_id`

export const PREDICTION_CHILD = `${process.env.REACT_APP_API_URL}/prediction_child/prediction/:prediction_id`

export const GET_GST = `${process.env.REACT_APP_API_URL}/get_gst/match/:match_id`

export const GET_TRADE_YES_AND_NO = `${process.env.REACT_APP_API_URL}/tarde_yes_no/:prediction_id/:limit`

export const GET_FANTASY_POINTS = `${process.env.REACT_APP_PYTHON_POINT_URL}`

export const IN_PLAY_JOINED_SLOTS = `${process.env.REACT_APP_API_URL}/total_joined_slots/:prediction_id/:match_id`

export const MAKE_GST_DATA = `${process.env.REACT_APP_API_URL}/make_gst_data/match/:match_id/series/:series_id/pred_type/:type`

export const GET_GST_MATCH_DATA = `${process.env.REACT_APP_API_URL}/match_data/pred_type/:type`

export const GET_MATCH_REVENUE = `${process.env.REACT_APP_API_URL}/match_data/details/:type`

export const GET_PRED_WISE_DATA = `${process.env.REACT_APP_API_URL}/match_data/pred_details/:type`

export const GET_PRO_PLAY_RUN_WISE_DATA = `${process.env.REACT_APP_API_URL}/match_data/run_wise`

export const IN_PLAY_GET_RECENT_RATES = `${process.env.REACT_APP_API_URL}/get_recent_rates/match/:match_id/prediction/:prediction_id`

export const GET_JOINED_RATES =`${process.env.REACT_APP_API_URL}/get_joined_on_rates/prediction/:prediction_id`

export const GET_MATCHED_COUNT = `${process.env.REACT_APP_API_URL}/matched_count/skiller/:skiller_id`

export const WINNING_SET_PASSWORD = `${process.env.REACT_APP_API_URL}/get_winning_set_password/match/:match_id/prediction/:prediction_id`

export const MOVE_TO_FINISH_TRADE = `${process.env.REACT_APP_API_URL}/move_to_finish/trade/:trade_id/match/:match_id/series/:series_id`

export const SALE_TARDE_ACTIVE = `${process.env.REACT_APP_API_URL}/update_sale_by_admin/:trade_id`

export const CHANGE_ALL_PREDICTION_STATUS = `${process.env.REACT_APP_API_URL}/change_all_prediction_status_for_match/:match_id/:sport/:status`

export const ACTIVE_ALL_PREDICTION_SALE = `${process.env.REACT_APP_API_URL}/active_all_prediction_sale_for_match/:match_id/:sport`

export const REFRESH_TOKEN = `${process.env.REACT_APP_API_URL}/refresh_token`


export const apiBaseUrl = `${process.env.REACT_APP_API_URL}`